import React from 'react';
import styled from 'styled-components';
import icon from '../../../../assets/images/lessonbuilder/icon.png'
import photo from '../../../../assets/images/lessonbuilder/photo.png'
import video from '../../../../assets/images/lessonbuilder/video.png'
import text from '../../../../assets/images/lessonbuilder/text.png'
import col3 from '../../../../assets/images/lessonbuilder/col3.png'
import col2 from '../../../../assets/images/lessonbuilder/col2.png'
import col4 from '../../../../assets/images/lessonbuilder/4col.png'

const Wrapper = styled.div`
    width: 120px;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;

    p {
        margin: 0 !important;
    }
`

const AssetButtons = styled.div`
    display: ${props => props.show ? 'flex' : 'none'} ;
    position: absolute;
    width: 240px;
    justify-content: center;

    .btn-add {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        background-color: transparent;
        border: none;

        img {
            max-width: 48px;
            max-height: 48px;
        }
    }
`

class AddHandle extends React.PureComponent {
    state = {
        buttonsOn: false
    }

    assetButtonsOff = () => {
        this.setState({buttonsOn: false});
    }
    assetButtonsOn = () => {
        this.setState({buttonsOn: true});
    }

    addAsset = (type, level) => {
        this.props.clickAdd(type, level, this.props.columnIndex);
    }
    render() {
        return(
            <Wrapper onMouseEnter = {this.assetButtonsOn} onMouseLeave = {this.assetButtonsOff} >
                {/* implement onMouseOver or onMouseEnter */}
                <p>Add</p>
                <AssetButtons show = {this.state.buttonsOn} >
                    <button onClick = {this.addAsset.bind(this, 'icon', this.props.level)} className="btn-add"><img src={icon} alt=""/></button>
                    <button onClick = {this.addAsset.bind(this, 'image', this.props.level)} className="btn-add"><img src={photo} /> </button>
                    <button onClick = {this.addAsset.bind(this, 'video', this.props.level)} className="btn-add"><img src={video} /> </button>
                    <button onClick = {this.addAsset.bind(this, 'text', this.props.level)} className="btn-add"><img src={text} /></button>
                    <button onClick = {this.addAsset.bind(this, '2col',this.props.level)} style={{display: this.props.level === 'row' ? 'block' : 'none' }} className="btn-add"><img src={col2} /></button>
                    <button onClick = {this.addAsset.bind(this, '3col',this.props.level)} style={{display: this.props.level === 'row' ? 'block' : 'none' }} className="btn-add"><img src={col3} /></button>
                    <button onClick = {this.addAsset.bind(this, '4col',this.props.level)} style={{display: this.props.level === 'row' ? 'block' : 'none' }} className="btn-add"><img src={col4} /></button>
                </AssetButtons>
            </Wrapper>
        )
    }
}

export default AddHandle;


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/AddHandle/AddHandle.Component.jsx